import { ChangeEvent, FC } from "react";
import styled from "styled-components";

const CheckboxFieldHidden = styled.input`
	display: none;
`;

const CheckboxFieldChecked = styled.div`
	width: 24px;
	height: 24px;
	background: #000000;
	background: ${props => props.theme.colors.primary};
	border: 1px solid ${props => props.theme.colors.primary};
	box-sizing: border-box;
	border-radius: 5px;
	margin: 8px;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: center;
	align-items: center;
	align-content: center;
	padding: 0px;
`;

const CheckboxFieldUnchecked = styled.div`
	width: 24px;
	height: 24px;
	background: #ffffff;
	border: 2px solid #d8dbe4;
	box-sizing: border-box;
	border-radius: 5px;
	margin: 8px;
`;

const CheckboxFieldWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: center;
	align-content: center;
`;

const CheckboxLabelWrapper = styled.div`
	font-family: Livvic;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	color: #000000;
`;

interface CheckboxFieldProps {
	checked: boolean;
	handleCheckboxChange: (value: boolean) => void;
	label?: string;
}

const CheckboxField: FC<CheckboxFieldProps> = ({ checked, handleCheckboxChange, label }) => {
	const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
		const target = event.target;
		const value = target.checked;
		handleCheckboxChange(value);
	};

	return (
		<CheckboxFieldWrapper>
			{checked ? (
				<CheckboxFieldChecked onClick={() => handleCheckboxChange(false)}>
					<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M12.8368 0.228457C13.0544 0.533066 13.0544 1.02693 12.8368 1.33154L4.66539 12.7715C4.44781 13.0762 4.09505 13.0762 3.87747 12.7715L0.163183 7.57154C-0.0543945 7.26693 -0.0543945 6.77307 0.163183 6.46846C0.380761 6.16385 0.733525 6.16385 0.951102 6.46846L4.27143 11.1169L12.0489 0.228457C12.2665 -0.0761522 12.6192 -0.0761522 12.8368 0.228457Z"
							fill="#181F32"
						/>
					</svg>
				</CheckboxFieldChecked>
			) : (
				<CheckboxFieldUnchecked onClick={() => handleCheckboxChange(true)} />
			)}
			<CheckboxFieldHidden type="checkbox" checked={checked} onChange={handleInputChange} />
			{label && <CheckboxLabelWrapper>{label}</CheckboxLabelWrapper>}
		</CheckboxFieldWrapper>
	);
};

export default CheckboxField;
